import React from 'react';
import PropTypes from 'prop-types';
import RatingSelector from './RatingSelector';
import ReviewStepHeader from '../UI/ReviewStepHeader';
import { Collapse } from 'antd';
import { RatingType } from '../data/RatingType';

const { Panel } = Collapse;

RatingsEditor.propTypes = {
	ratingsDataEditor: PropTypes.object,
};

export default function RatingsEditor({ ratingsDataEditor }) {
	const getAssessment = type => {
		return ratingsDataEditor.get(type);
	};

	const renderOverallRatingSelector = () => {
		return (
			<RatingSelector
				label={
					<span>
						<b>Overall Rating</b>
					</span>
				}
				ratingsDataEditor={ratingsDataEditor}
				assessment={getAssessment(RatingType.overall)}
			/>
		);
	};

	return (
		<div className="ratings-editor editor-root">
			<ReviewStepHeader label="Rate (1/3)" icon="star" />
			<div>
				{renderOverallRatingSelector()}
				<Collapse bordered={false}>
					<Panel header="More Ratings" key="1">
						<RatingSelector
							label="Originality"
							ratingsDataEditor={ratingsDataEditor}
							assessment={getAssessment(RatingType.originality)}
						/>
						<RatingSelector
							label="Writing Quality"
							ratingsDataEditor={ratingsDataEditor}
							assessment={getAssessment(
								RatingType.writingQuality,
							)}
						/>
						<RatingSelector
							label="Intellectual Depth"
							ratingsDataEditor={ratingsDataEditor}
							assessment={getAssessment(
								RatingType.intellectualDepth,
							)}
						/>
						<RatingSelector
							label="Character Development"
							ratingsDataEditor={ratingsDataEditor}
							assessment={getAssessment(
								RatingType.characterDevelopment,
							)}
						/>
						<RatingSelector
							label="'Couldn't Put It Down'-ness"
							ratingsDataEditor={ratingsDataEditor}
							assessment={getAssessment(
								RatingType.couldntPutItDownness,
							)}
						/>
						<RatingSelector
							label="Image or Illustration Quality"
							ratingsDataEditor={ratingsDataEditor}
							assessment={getAssessment(
								RatingType.imageIllustrationQuality,
							)}
						/>
					</Panel>
				</Collapse>
			</div>
		</div>
	);
}
